<button class="back-to-top-button" (click)="scrollToTop()" *ngIf="showBackToTopButton">
  <i class="fa-solid fa-angle-up"></i>
</button>